import React from "react";
import ReactDOM from "react-dom/client";
import { HighscaleProvider } from "highscale/react";
import { App } from "./App";
import "./design.css";
import "./styles.css";

// HighscaleProvider sets up the deployment-bound lex Client + a
// default query cache so every useQuery/useProcedure/useAuth
// inside the tree just works.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HighscaleProvider>
      <App />
    </HighscaleProvider>
  </React.StrictMode>,
);
